import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, createNestablePublicClientApplication } from '@azure/msal-browser';
import { App } from './app/App';
import { configureAppStore } from './redux/store';
import { browserMsalConfig, teamsMsalConfig } from './services/auth/msalConfig';
import { resolveAuthEnvironment } from './services/auth/AuthEnvironmentResolver';
import { initializeAppInsights } from './app/telemetry/appInsights';
import { getPlaywrightTestSetup } from './features/utils/PlaywrightTestSetup';
import './index.css';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Could not find root element');
}

void (async () => {
    // resolveAuthEnvironment initializes TeamsJS as its first step.
    // This must happen before MSAL is constructed (NAA requirement).
    const environment = await resolveAuthEnvironment();

    const playwrightTestSetup = getPlaywrightTestSetup();

    // Teams: use createNestablePublicClientApplication to enable the NAA broker protocol
    // Browser/SharePoint: use the standard PublicClientApplication
    const msalInstance = playwrightTestSetup?.createMsalInstance
        ? await playwrightTestSetup.createMsalInstance(environment)
        : environment.isInTeams && !environment.isSharePoint
          ? await createNestablePublicClientApplication(teamsMsalConfig)
          : new PublicClientApplication(browserMsalConfig);
    const store = configureAppStore(msalInstance);

    initializeAppInsights();

    const root = ReactDOM.createRoot(container);

    root.render(
        <React.StrictMode>
            <App msalInstance={msalInstance} store={store} isInTeams={environment.isInTeams} />
        </React.StrictMode>,
    );
})();
